import { SliceType } from 'components/MCTextEditor/slice/types'
import { IVariableData } from 'components/MCTextEditor/types'
import {
  createDelete,
  createInsert,
} from 'components/RichTextEditor/processor/actions/textProcessorActions'
import { ITextProcessorMiddleware } from 'components/RichTextEditor/processor/constants'
import { createRange, shrinkRange } from 'components/RichTextEditor/processor/range'

export const createUpdateVariable =
  (getLabelByID: (id: string) => string): ITextProcessorMiddleware =>
  (api) =>
  (next) =>
  (action) => {
    if (!action || action.type !== 'slice-data') {
      return next(action)
    }
    const { slice } = action
    if (!slice || slice.type !== SliceType.VARIABLE || !slice.data) {
      return next(action)
    }

    const sliceData = action.slice.data as IVariableData
    const actionData = action.data as IVariableData

    if (sliceData.id === actionData.id) {
      return next(action)
    }

    const result = next(action)
    const labelRange = shrinkRange(slice.range)
    if (labelRange) {
      const newLabel = getLabelByID(actionData.id)
      const newSlice = { ...slice, data: actionData, range: createRange(0, newLabel.length) }
      api.dispatch(createInsert(labelRange.end, newLabel, [newSlice]))
      api.dispatch(createDelete(labelRange.start, labelRange.length))
    }
    return result
  }
